import { render, staticRenderFns } from "./index-v3.vue?vue&type=template&id=43d9f22e&"
import script from "./index-v3.vue?vue&type=script&lang=js&"
export * from "./index-v3.vue?vue&type=script&lang=js&"
import style0 from "./index-v3.vue?vue&type=style&index=0&id=43d9f22e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports